import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken } from '../../GlobalStateContainer/actions'
import $ from 'jquery'

const EMULATION_MODE_SOWS = false


/*
 * Scope of Work Actions
 * 
 */

export function fetchSowsList(user) {
    let cmd = 'FETCH_SOWS_LIST'

    if (EMULATION_ALL || EMULATION_MODE_SOWS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productBrickId: 1,
                            name: 'Species',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMDEX',
                            example: 'Oak'
                        },
                        {
                            productBrickId: 2,
                            name: 'Brand Name',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMMFG',
                            example: 'Bal'
                        },
                        {
                            productBrickId: 3,
                            name: 'Edge',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'Rounded',
                            example: 'Rounded'
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            var url = buildRequestUrl('SOWprojects');
            axios.post(url, JSON.stringify(user), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchSowError(dispatch) {

    dispatch(
        {
            type: 'FETCH_SOW_ERROR',
        }
    )
}

export function fetchSowAnswers(id, reviewTab) {
    let cmd = 'FETCH_SOW_ANSWERS'

    if (EMULATION_ALL || EMULATION_MODE_SOWS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productBrickId: 1,
                            name: 'Species',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMDEX',
                            example: 'Oak'
                        },
                        {
                            productBrickId: 2,
                            name: 'Brand Name',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMMFG',
                            example: 'Bal'
                        },
                        {
                            productBrickId: 3,
                            name: 'Edge',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'Rounded',
                            example: 'Rounded'
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: reviewTab
                }
            )

            var url = buildRequestUrl('SOWprojectsanswers/') + id;
            axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorSow(dispatch) {

    dispatch(
        {
            type: 'SOW_ERROR',
        }
    )
}

export function deleteProject(id) {
    let cmd = 'DELETE_SCOPE'

    if (EMULATION_ALL || EMULATION_MODE_SOWS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('DeleteSOWprojects/') + id, "", { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function exportProject(id) {
    let cmd = 'EXPORT_SCOPE'

    if (EMULATION_ALL || EMULATION_MODE_SOWS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('ExportSOWproject/') + id, { responseType: 'blob', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )

                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');

                    link.href = url;
                    link.setAttribute('download', "Scope_Of_Work.pdf");

                    document.body.appendChild(link);
                    link.click();
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchTemplates() {
    let cmd = 'FETCH_SOW_TEMPLATES'

    if (EMULATION_ALL || EMULATION_MODE_SOWS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productBrickId: 1,
                            name: 'Species',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMDEX',
                            example: 'Oak'
                        },
                        {
                            productBrickId: 2,
                            name: 'Brand Name',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMMFG',
                            example: 'Bal'
                        },
                        {
                            productBrickId: 3,
                            name: 'Edge',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'Rounded',
                            example: 'Rounded'
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            var url = buildRequestUrl('SOWprojecttypetemplate');
            axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function createProjectTab(id, tab) {
    let cmd = 'CREATE_SOW'

    if (EMULATION_ALL || EMULATION_MODE_SOWS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productBrickId: 1,
                            name: 'Species',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMDEX',
                            example: 'Oak'
                        },
                        {
                            productBrickId: 2,
                            name: 'Brand Name',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMMFG',
                            example: 'Bal'
                        },
                        {
                            productBrickId: 3,
                            name: 'Edge',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'Rounded',
                            example: 'Rounded'
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            var url = buildRequestUrl('SOWproject/') + id
            axios.post(url, JSON.stringify(tab), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateProjectTab(id, tab) {
    let cmd = 'UPDATE_SOW'

    if (EMULATION_ALL || EMULATION_MODE_SOWS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: tab
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('SOWprojects/') + id, JSON.stringify(tab), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}



